import { requestRaw } from './request';

export function getWeatherTemplate(): Promise<Blob> {
  return requestRaw('GET', '/api/weather/download-template/', {}, { version: 1, injectTenant: true });
}
